import { CARD_HEIGHT, CARD_WIDTH, Game } from '@phaser/scenes/Game';
import { CardObject } from '@phaser/objects/Card.object';

export class ActiveCritBehavior {
  private _scene = Game.current;

  private _marker?: Phaser.GameObjects.Image;

  constructor(private _card: CardObject) {}

  public setActiveCrit() {
    const pad = CARD_WIDTH / 4;
    const x = Math.random() * (CARD_WIDTH - pad * 2) - (CARD_WIDTH / 2) + pad;
    const y = Math.random() * (CARD_HEIGHT - pad * 2) - (CARD_HEIGHT / 2) + pad;

    this._marker = this._scene.add.image(x, y, 'sprites', 'crosshair')
      .setTint(0xFF0000);
    this._card.container.add(this._marker);

    this._scene.add.tween({
      targets: this._marker,
      duration: 200,
      alpha: { from: 0, to: 1 },
      scale: { from: 1, to: 0.65 },
      forward: true,
    });

    this._scene.add.tween({
      targets: this._marker,
      rotation: Math.PI * 2,
      duration: 2000,
      repeat: -1,
    });

    this._scene.add.tween({
      targets: this._marker,
      delay: 1800,
      duration: 200,
      alpha: { from: 0, to: 1 },
      scale: { from: 0.5, to: 1 },
      onComplete: () => this._marker?.destroy()
    });
  }

  public destroy() {
    this._marker?.destroy();
  }
}